var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('router-link',{staticClass:"pt-20 logo",attrs:{"to":"/"}},[_c('img',{attrs:{"alt":"Uni logo","src":require("../assets/logo.svg")}})]),_c('main-menu'),_c('mobile-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }